import { BillingCustom } from '@/api/index'

export function getBillingTemplateList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/GetBillingTemplateList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function getBillingTemplateHistoryList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/GetBillingTemplateHistoryList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function SetBillingTemplateHistoryList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/SetBillingTemplateHistoryList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function SetBillingTemplateList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/SetBillingTemplateList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function DeleteBillingTemplateList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/DeleteBillingTemplateList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function AddBillingTemplateList (data) {
  return BillingCustom.request({
    method: 'post',
    url: '/AddBillingTemplateList',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
